import { useEffect } from "react";

import { isMiniApp } from "../auth";
import { useWebChrome } from "../webChrome";

type Options = {
  text: string;
  visible: boolean;
  enabled?: boolean;
  loading?: boolean;
  onClick: () => void;
};

/** Управление главной кнопкой: нативной в Mini App, фолбэком в вебе. */
export function useMainButton(opts: Options) {
  const { text, visible, enabled = true, loading = false, onClick } = opts;
  const setMain = useWebChrome()?.setMain;

  // Mini App: нативный Telegram MainButton.
  useEffect(() => {
    if (!isMiniApp()) return;
    const btn = window.Telegram?.WebApp?.MainButton;
    if (!btn) return;

    btn.setText(text);
    if (enabled) btn.enable();
    else btn.disable();
    if (loading) btn.showProgress(true);
    else btn.hideProgress();

    if (visible) btn.show();
    else btn.hide();

    btn.onClick(onClick);
    return () => {
      btn.offClick(onClick);
      btn.hideProgress();
      btn.hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, visible, enabled, loading, onClick]);

  // Веб: фолбэк-кнопка через WebChrome.
  useEffect(() => {
    if (isMiniApp() || !setMain) return;
    setMain({ text, visible, enabled, loading, onClick });
    return () => setMain(null);
  }, [setMain, text, visible, enabled, loading, onClick]);
}
